/** Matches `message_templates` `varchar(255)` columns (template_name, sender_name, location). */
export const MESSAGE_TEMPLATE_VARCHAR_MAX = 255;

/** Matches `message_templates` message body `varchar(320)` columns. */
export const MESSAGE_TEMPLATE_MESSAGE_BODY_MAX = 320;
